"use client";

import { Fragment, useContext, useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import ClearIcon from "@mui/icons-material/Clear";
import Link from "next/link";
import OverlayScrollbar from "@/components/overlay-scrollbar";
import ListItem from "@/components/page-sidenav/side-navbar/components/list-item";
import Accordion from "@/components/page-sidenav/side-navbar/components/nav-accordion";
import { AuthContext } from "contexts/AuthContext";
import { usePathname } from "next/navigation";

export default function MobileMenu({ navigation }) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const handleOpen = () => setOpenDrawer(true);
  const handleClose = () => setOpenDrawer(false);
  const { auth, logout } = useContext(AuthContext);
  const pathname = usePathname();

  const isHome = pathname === "/";

  return (
    <Fragment>
      <IconButton onClick={handleOpen} sx={{ flexShrink: 0, color: "grey.600" }}>
        <MenuIcon />
      </IconButton>

      <Drawer
        anchor="left"
        open={openDrawer}
        onClose={handleClose}
        sx={{ zIndex: 15001 }}
      >
        <Box width="100vw" height="100%" position="relative">
          <OverlayScrollbar sx={{ height: "100vh" }}>
            <Box
              px={3}
              py={5}
              position="relative"
              height="100%"
            >
              {/* CLOSE BUTTON */}
              <IconButton
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 20,
                  top: 20,
                }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>

              {/* SECTION TITLE */}
              <Box padding="10px 10px 4px 20px">
                <Typography variant="h5" fontWeight="bold">
                  Categorías
                </Typography>

              </Box>
              <Box padding="12px 20px 4px 20px">

                {/* NAVIGATION LIST */}
                {navigation?.map(({ name, has_subcategories, categoryItem, slug, photo }, idx) => (
                  <Box key={slug || name || idx} mb={0}> {/* Reduce mb para menos espacio */}
                    {has_subcategories && categoryItem ? (
                      categoryItem.map((item, subIdx) => (
                        item.child && (
                          <Accordion item={item} key={item.slug || subIdx} />
                        )
                      ))
                    ) : (
                      <Box mt={1} sx={{ textDecoration: "none", display: "block" }}>

                        <Link prefetch={false} href={isHome ? slug || "#" : `/${slug}`} passHref>
                          <ListItem item={{ name, slug, photo }} />
                        </Link>
                      </Box>

                    )}
                  </Box>
                ))}
              </Box>

              {/* ACCOUNT OPTIONS */}
              {auth.isAuthenticated &&
                <Box mt={4} px={2} p={2}>
                  <Link prefetch={false} href="/profile" passHref>

                    <Box
                      sx={{
                        display: "block",
                        padding: "10px 0",
                        borderBottom: "1px solid #e0e0e0",
                        color: "text.primary",
                        textDecoration: "none",
                      }}
                    >
                      <Typography variant="h5" fontWeight="bold">
                        Mi cuenta
                      </Typography>
                    </Box>
                  </Link>
                  <Link prefetch={false} href="/logout" passHref>
                    <Box
                      sx={{
                        display: "block",
                        padding: "10px 0",
                        color: "text.primary",
                        textDecoration: "none",
                      }}
                      onClick={async () => {
                        await logout()
                        window.location.href = '/';

                      }}
                    >
                      <Typography variant="h5" fontWeight="bold">
                        Cerrar sesión
                      </Typography>

                    </Box>
                  </Link>
                </Box>}
            </Box>
          </OverlayScrollbar>
        </Box>
      </Drawer>
    </Fragment>
  );
}
